import { render, staticRenderFns } from "./dialogAddressRedeemFinal.vue?vue&type=template&id=8396c48e"
import script from "./dialogAddressRedeemFinal.vue?vue&type=script&lang=js"
export * from "./dialogAddressRedeemFinal.vue?vue&type=script&lang=js"
import style0 from "./dialogAddressRedeemFinal.vue?vue&type=style&index=0&id=8396c48e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports